import api from "../api";

export const estadoCivilService = {
  async loadStatusCivil() {
    return await api.get("/estados-civis");
  },
};
